export interface AliasScope {
  get(id: string): string;
  peek(id: string): string | undefined;
}

export function createAliasScope(prefix: string, orderedIds: Iterable<string> = []): AliasScope {
  const aliasById = new Map<string, string>();
  let nextIndex = 0;

  function assign(id: string): string {
    const existing = aliasById.get(id);
    if (existing) return existing;
    const alias = `${prefix}${nextIndex}`;
    nextIndex += 1;
    aliasById.set(id, alias);
    return alias;
  }

  for (const id of orderedIds) {
    assign(id);
  }

  return {
    get(id: string): string {
      return assign(id);
    },
    peek(id: string): string | undefined {
      return aliasById.get(id);
    },
  };
}
